import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { Country } from '@/constants';
import type { VatValidationResponseDto } from '@/types/dtos/organizations/response/vat-validation.dto';

type VatValidationRequestDto = {
  vat: string;
  country: Country;
};

export function useVatValidationMutation() {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (data: VatValidationRequestDto) => {
      const token = await getToken();
      return vatValidation(data, token ?? '');
    },
  });
}

const vatValidation = async (data: VatValidationRequestDto, token: string): Promise<VatValidationResponseDto> => {
  const url = `${import.meta.env.VITE_API_URL}/vat-validation/validate`;
  return sendJSONRequest({ url, method: METHOD.POST, body: data, token });
};
